import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";

import {Radio} from "@mui/material";

import RadioButtonIcon from "components/icons/RadioButtonIcon";

import ApplicationName from "./ApplicationName";
import {SidebarFloatMenuContext} from "../../SidebarFloatMenu";
import {BottomDrawerContext} from "../../BottomDrawer";
import {SidebarContext} from "../../../../../SidebarContext";

ApplicationButton.propTypes = {
    to: PropTypes.string,
    application: PropTypes.number.isRequired,
    selected: PropTypes.bool,
    onClick: PropTypes.func
};

function ApplicationButton({to, application, selected = false, onClick = () => {}}) {
    const {onClose} = useContext(SidebarFloatMenuContext);
    const {handleClose: onCloseMobile} = useContext(BottomDrawerContext);
    const {closeSidebar} = useContext(SidebarContext);

    const content = (
        <div
            onClick={(e) => {
                onClick(e);
                onClose();
                onCloseMobile();
                closeSidebar();
            }}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px 0px 8px 8px',
                cursor: 'pointer'
            }}
        >
            <ApplicationName application={application} selected={selected} />
            <Radio
                icon={<RadioButtonIcon />}
                checkedIcon={<RadioButtonIcon checked />}
                checked={selected}
            />
        </div>
    );

    if (to) {
        return (
            <Link to={to} style={{ textDecoration: 'none' }}>
                {content}
            </Link>
        )
    }

    return content;
}

export default ApplicationButton;
